import { useCallback, useEffect, useRef } from "react";
import { useOrderHandlers } from "./toolbar/useOrderHandlers.js";
import { useFetchTree } from "./useFetchTree.js";
import { applyModalTreeDestroy, applyModalTreeInit } from "../../backbone/modal.js";
import { useAppTreeControllerRef } from "../../contexts/appTreeControllerContext.js";
import { useAppTreeLocalState } from "../../contexts/appTreeLocalStateContext.js";
import { useAppTreeMountContext } from "../../contexts/appTreeMountContext.js";
import { getDefaultFolder } from "../../integrations/defaultFolder.js";
import { applyUploaderTreeInit } from "../../upload/uploader.js";
import { rmlOpts } from "../../utils/rmlOpts.js";
function useAppTreeMount() {
    const { id, attachmentsBrowser, isModal, isResizable, isSticky, isStickyHeader, isFullWidth, style } = useAppTreeMountContext();
    const controllerRef = useAppTreeControllerRef();
    const { setResolvedInitialSelectedId, setIsMoveable, setIsWPAttachmentsSortMode } = useAppTreeLocalState();
    const fetchTree = useFetchTree();
    const { handleOrderClick } = useOrderHandlers();
    const initCalled = useRef(false);
    const handleResize = useCallback(()=>{
        attachmentsBrowser && attachmentsBrowser.attachments?.setColumns();
    }, [
        attachmentsBrowser
    ]);
    useEffect(()=>{
        if (initCalled.current) {
            return;
        }
        initCalled.current = true;
        const selectedId = getDefaultFolder();
        const defaultInitialSelectedId = !selectedId || selectedId === "all" ? "all" : +selectedId;
        const initState = {
            initialSelectedId: defaultInitialSelectedId,
            isModal,
            isMoveable: true,
            isWPAttachmentsSortMode: false,
            isResizable,
            isSticky,
            isStickyHeader,
            isFullWidth,
            style
        };
        const treeInitProps = {
            id,
            attachmentsBrowser,
            isModal
        };
        applyUploaderTreeInit(initState, treeInitProps);
        applyModalTreeInit(controllerRef.current, initState, treeInitProps);
        initState.isMoveable !== undefined && setIsMoveable(initState.isMoveable);
        initState.isWPAttachmentsSortMode !== undefined && setIsWPAttachmentsSortMode(initState.isWPAttachmentsSortMode);
        setResolvedInitialSelectedId(initState.initialSelectedId);
        fetchTree(initState.initialSelectedId);
        handleResize();
        if (rmlOpts.others.listMode === "list" && window.location.hash === "#order") {
            handleOrderClick({});
            window.location.hash = "";
        }
        return ()=>{
            applyModalTreeDestroy(controllerRef.current, initState, {
                isModal,
                store: controllerRef.current.props.store
            });
        };
    }, []);
}
export { useAppTreeMount };
